import { useMemo } from 'react';
import { FormControls } from '@elementary/common-ui/components';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm, ColumnResource } from 'shared/types';
import { getConditionalSeverityString } from 'testManagement/utils/utils';

type Props = {
  watch: UseFormWatch<AddTestForm>;
  columnsResourcesData: ColumnResource[];
};

const ColumnsRelationshipConfig = ({ watch, columnsResourcesData }: Props) => {
  const resources = watch('resources');
  const columnName = watch('columnName');
  const tableName = watch('tableName');

  const target = useMemo(() => {
    if (resources.length > 1) {
      return null;
    }
    const resource = resources[0];
    return columnsResourcesData.find((col) => col.id === resource);
  }, [columnsResourcesData, resources]);

  const { warnIf, errorIf } = getConditionalSeverityString(watch('severity'));

  return (
    <>
      <SeverityRenderer
        severity={watch('severity')?.type || 'error'}
        warnIf={warnIf}
        errorIf={errorIf}
      />

      {target ? (
        <FormControls.FormText>
          Each existing <b>{target.name}</b> column in the{' '}
          <b>{target.model_name}</b> table should have a correlating{' '}
          <b>{columnName}</b> in the <b>{tableName}</b> table
        </FormControls.FormText>
      ) : (
        <FormControls.FormText>
          Each existing column should have a correlating <b>{columnName}</b> in
          the <b>{tableName}</b> table
        </FormControls.FormText>
      )}
    </>
  );
};

export default ColumnsRelationshipConfig;
